import React from 'react';
import ReactDOM from 'react-dom';
import BrailleDisplaySimulator from './components/BrailleDisplaySimulator';
import './index.css';

ReactDOM.render(<BrailleDisplaySimulator />, document.getElementById('root'));
